import { render, staticRenderFns } from "./VEmployeesBrowseOld.vue?vue&type=template&id=70b2cb84&scoped=true&lang=pug&v-cloak=true&v-if=init"
import script from "./VEmployeesBrowseOld.vue?vue&type=script&lang=ts"
export * from "./VEmployeesBrowseOld.vue?vue&type=script&lang=ts"
import style0 from "./VEmployeesBrowseOld.vue?vue&type=style&index=0&id=70b2cb84&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b2cb84",
  null
  
)

/* custom blocks */
import block0 from "./EmployeesBrowse.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fmodules%2FEmployees%2FBrowse%2FVEmployeesBrowseOld.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports